<script>
import List from "@/components/molecules/list/index";
import ListItem from "@/components/molecules/list/list-item";

export default {
  name: "AdresseLadRecap",
  components: {
    List,
    ListItem
  },
  props: {
    adresseLad: {
      type: Object,
      required: true
    }
  },
  computed: {
    conditionAcces() {
      const list = [];
      if (this.adresseLad.attributes.centre_ville) {
        list.push("Centre ville");
      }
      if (this.adresseLad.attributes.voie_sans_issue) {
        list.push("Voie sans issue");
      }
      if (this.adresseLad.attributes.sens_unique) {
        list.push("Sens unique");
      }
      if (this.adresseLad.attributes.rue_pietonne) {
        list.push("Rue piétonne");
      }
      if (this.adresseLad.attributes.access_semi_remorque) {
        list.push("Accès semi-remorque");
      }
      if (this.adresseLad.attributes.residence) {
        list.push("Résidence");
      }
      return list;
    }
  }
};
</script>

<template>
  <List class="u-font-14">
    <ListItem class="u-flex u-flex-wrap u-mb-xs">
      <strong class="u-font-500">
        Type d'habitation :&nbsp;
      </strong>
      {{ uppercaseFirstLetter(adresseLad.attributes.type_habitation) }}
    </ListItem>
    <ListItem class="u-flex u-flex-wrap u-mb-xs">
      <strong class="u-font-500">Étage :&nbsp;</strong>
      {{ adresseLad.attributes.etage }}
    </ListItem>
    <ListItem
      v-if="adresseLad.attributes.digicode2"
      class="u-flex u-flex-wrap u-mb-xs"
    >
      <strong class="u-font-500">Digicode 1 :&nbsp;</strong>
      {{ adresseLad.attributes.digicode1 }}
    </ListItem>
    <ListItem
      v-if="adresseLad.attributes.digicode2"
      class="u-flex u-flex-wrap u-mb-xs"
    >
      <strong class="u-font-500">Digicode 2 :&nbsp;</strong>
      {{ adresseLad.attributes.digicode2 }}
    </ListItem>
    <ListItem class="u-flex u-flex-wrap u-mb-xs">
      <strong class="u-font-500">Ascenseur :&nbsp;</strong>
      {{ booleanToText(adresseLad.attributes.ascenseur) }}
    </ListItem>
    <ListItem class="u-flex u-flex-wrap u-mb-md">
      <strong class="u-font-500">Interphone :&nbsp;</strong>
      {{ booleanToText(adresseLad.attributes.interphone) }}
    </ListItem>
    <ListItem
      v-if="adresseLad.attributes.info_livreur"
      class="u-flex u-flex-column u-mb-md"
    >
      <strong class="u-font-500">
        Informations pour le livreur :
      </strong>
      <p>
        {{ adresseLad.attributes.info_livreur }}
      </p>
    </ListItem>
    <ListItem
      v-if="conditionAcces.length !== 0"
      class="u-flex u-flex-column"
    >
      <strong class="u-font-500">
        Conditions d'accès :
      </strong>
      <p class="u-mt-xxs">
        <template
          v-for="(value, index) in conditionAcces"
          :key="`access-${index}`"
        >
          <template v-if="index !== 0">
            {{ " | " }}
          </template>
          {{ value }}
        </template>
      </p>
    </ListItem>
  </List>
</template>

<style></style>
